import React from "react";
import styles from "./LatestPostHeader.module.css";
import { useNavigate } from "react-router-dom";

const LatestPostHeader = (props: {
  demo: string;
  margin: string;
  title: string;
}) => {
  let navigate = useNavigate();

  const routeChange = () => {
    let path = `${props.title.includes("Posts") ? "/writings" : "/projects"}`;
    navigate(path);
  };

  return (
    <div className={props.demo}>
      <div
        className={
          props.demo === ""
            ? styles.SubHeading + " " + styles.MainMargin
            : styles.SubHeading
        }
      >
        {props.title}
      </div>
      <div
        className={props.demo === "" ? styles.AboutMeHide : styles.AboutMe}
        onClick={routeChange}
      >
        View All
      </div>
    </div>
  );
};

export default LatestPostHeader;
